import { render, staticRenderFns } from "./ProducerReportsShops.vue?vue&type=template&id=58f23066&"
import script from "./ProducerReportsShops.vue?vue&type=script&lang=js&"
export * from "./ProducerReportsShops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports